export default "__VITE_ASSET__59c8321d__"